import utils from '@/js/utils';
import MENU_ATRIBUTOS from '@/configs/menus/attributes.menu';
import { ROLES_LIST } from '@/js/constants';
export default [{
  path: '/attributes/overview',
  name: 'overview',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/pages/OverviewPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('overview', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/history',
  name: 'ownership_history',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/OwnershipHistoryPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ownership_history', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/sandboxes',
  name: 'sandboxes',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/SandboxListPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('sandboxes', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/requests',
  name: 'ownership_requests',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/OwnershipRequestPage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('requests', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/manage_production',
  name: 'manage_production',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/ManageProductization');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('requests', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/productize_model',
  name: 'productize_model',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/ProductizeModelPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('productize_model', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/productize_use_case',
  name: 'productize_model',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/ProductizeUseCase.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('productize_use_case', MENU_ATRIBUTOS)
  }
}, {
  path: '/attributes/use_cases/productize_transformed_attributes',
  name: 'productize_transformed_attributes',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/ProductizeTransformedAttributes.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN]
  }
}, {
  path: '/attributes/use_cases/productize_usecase_audiences',
  name: 'productize_usecase_audiences',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/ProductizeUseCaseDigitalAudiencesPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/search',
  name: 'attributes_search',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/SearchPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/search/user-groups',
  name: 'user_groups_search',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/UserGroupsPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/search/list',
  name: 'list_search',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/SearchListPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/sandbox/request',
  name: 'sandbox_request',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/SandboxRequest.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/selected',
  name: 'attributes_selected',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/SelectedAttributesPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/groups',
  name: 'groups',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/components/GroupAttribute.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/managment/attribute_master',
  name: 'attribute_master',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/managment/AttributeMaster');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }
}, {
  path: '/attributes/managment/metrics',
  name: 'metrics',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/managment/AttributeMetrics.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }
}, {
  path: '/attributes/managment/manage_metrics',
  name: 'manage_metrics',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/managment/AdminAttributeMetrics.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }
}, {
  path: '/attributes/quality-report',
  name: 'quality_report',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/pages/QualityReport.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/managment/quality-report',
  name: 'manage_quality_report',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/managment/AdminQualityReport.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/quality-report/shared',
  name: 'quality_report_shared',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/pages/QualityReportShared.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/quality-report/consistency',
  name: 'quality_report_consistency',
  component: function component() {
    return import('@/apps/attributes/pages/QualityReportConsistency.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/attributes/use_cases/create_attribute',
  name: 'create_attribute',
  component: function component() {
    return import(/* webpackChunkName: "attr-mkt" */'@/apps/attributes/modules/use_cases/CreateAttributePage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN]
  }
}];